export default {
    ADICAO_DE_CUSTO_SUBSEQUENTE: 'Adição de Custo Subsequente',
    REDUCAO_AO_VALOR_RECUPERAVEL: 'Redução ao valor recuperável'
}
